export default "__VITE_ASSET__DpHWc1Tc__"